module.exports = __webpack_public_path__ + "img/2.3168a67e.png";